import Config from 'Config';

import { createApiClient } from '../api-client-factory';

import { TokenResponse } from './types';

const client = createApiClient(`${Config.accounts_api_url}/v2/info`);

/**
 * Tokens API client.
 */
export const tokensClient = {
  /**
   * Get token details.
   */
  getInfo: async (accessToken: string) => client.get<TokenResponse>(``, accessToken),
};
